import { Link, Outlet, useLocation } from "react-router-dom";
import MainLayout from "../Container/Layout/MainLayout";
import { profileSideBarData } from "../Data";
import { useContext, useEffect, useState } from "react";
import { Context } from "../Context/Context";
import { Profile } from "../Services/ContectService";
import { toast } from "react-toastify";


const Account = () => {
    const { pathname } = useLocation();
    const { json, user, setLoading } = useContext(Context);
    const [userInformation, setUserInformation] = useState([]);

    const userHandeler = async () => {
        setLoading(true);
        try {
            const { status, data } = await Profile(user);
            if (status === 200) {
                setUserInformation(data);
            }
        } catch (error) {
            toast.error(json.toast.err_1);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        userHandeler();
    }, [])

    return (
        <MainLayout>
            <div className="flex flex-col lg:flex-row w-full justify-evenly">
                <div className="flex flex-col lg:w-[250px] w-full lg:pb-0 pb-4">
                    <div className="bg-blue-200 p-4 border border-black rounded-t-lg flex">
                        <svg width="30" height="30" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 0.46875C24.1593 0.46875 18.4497 2.20073 13.5933 5.44566C8.73694 8.6906 4.95185 13.3027 2.7167 18.6989C0.481545 24.095 -0.103272 30.0328 1.0362 35.7613C2.17567 41.4898 4.98825 46.7517 9.11827 50.8817C13.2483 55.0118 18.5103 57.8243 24.2388 58.9638C29.9673 60.1033 35.905 59.5185 41.3011 57.2833C46.6973 55.0482 51.3094 51.2631 54.5544 46.4067C57.7993 41.5503 59.5313 35.8407 59.5313 30C59.5226 22.1705 56.4085 14.6641 50.8722 9.12785C45.3359 3.59154 37.8295 0.477435 30 0.46875ZM16.7574 48.7496C18.2807 46.6668 20.2737 44.9727 22.5747 43.8049C24.8757 42.637 27.4196 42.0284 30 42.0284C32.5804 42.0284 35.1244 42.637 37.4253 43.8049C39.7263 44.9727 41.7193 46.6668 43.2426 48.7496C39.3723 51.4943 34.7448 52.9687 30 52.9687C25.2553 52.9687 20.6277 51.4943 16.7574 48.7496ZM22.3438 27.8125C22.3438 26.2982 22.7928 24.818 23.6341 23.5589C24.4754 22.2999 25.6711 21.3185 27.0701 20.739C28.4691 20.1596 30.0085 20.0079 31.4937 20.3034C32.9788 20.5988 34.3431 21.328 35.4138 22.3987C36.4845 23.4695 37.2137 24.8337 37.5092 26.3188C37.8046 27.804 37.6529 29.3434 37.0735 30.7424C36.494 32.1414 35.5127 33.3372 34.2536 34.1784C32.9945 35.0197 31.5143 35.4688 30 35.4688C27.9694 35.4688 26.0221 34.6621 24.5862 33.2263C23.1504 31.7905 22.3438 29.8431 22.3438 27.8125ZM48.0469 44.2023C45.9201 41.4973 43.2093 39.3081 40.1172 37.7984C42.0878 35.8029 43.4243 33.2691 43.9585 30.5158C44.4926 27.7626 44.2007 24.9128 43.1193 22.3251C42.0378 19.7374 40.2153 17.5273 37.8809 15.9728C35.5466 14.4183 32.8046 13.5889 30 13.5889C27.1954 13.5889 24.4535 14.4183 22.1191 15.9728C19.7847 17.5273 17.9622 19.7374 16.8808 22.3251C15.7994 24.9128 15.5074 27.7626 16.0415 30.5158C16.5757 33.2691 17.9122 35.8029 19.8828 37.7984C16.7907 39.3081 14.0799 41.4973 11.9531 44.2023C9.28178 40.816 7.61791 36.7458 7.15199 32.4579C6.68607 28.1699 7.43694 23.8374 9.31865 19.9563C11.2003 16.0752 14.1368 12.8024 17.792 10.5124C21.4471 8.22249 25.6731 7.00802 29.9863 7.00802C34.2995 7.00802 38.5256 8.22249 42.1807 10.5124C45.8358 12.8024 48.7723 16.0752 50.654 19.9563C52.5357 23.8374 53.2866 28.1699 52.8207 32.4579C52.3548 36.7458 50.6909 40.816 48.0195 44.2023H48.0469Z" fill="black" />
                        </svg>
                        <p className="font-extrabold mr-4 text-xl">{`${userInformation.name} ${userInformation.family}`}</p>
                    </div>
                    {profileSideBarData.map((item, index) => (
                        <Link
                            to={item.route}
                            key={index}
                            className={`border group hover:bg-blue-700 cursor-pointer
                            border-black py-2 px-4 flex items-center
                            ${index === profileSideBarData.length - 1 ? "rounded-b-lg" : ""} 
                            ${pathname === item.route ? "bg-blue-700 text-white" : ""}`}
                        >
                            <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="group-hover:fill-white" d={item.icon} fill={`${pathname === item.route ? 'white' : 'black'}`} />
                            </svg>
                            <p className="text-md mr-4 group-hover:text-white">{item.name}</p>
                        </Link>
                    )
                    )}
                </div>
                <Outlet />
            </div>
        </MainLayout>
    );
}

export default Account;